import { useEffect, useMemo, useState } from "react";
import { useLazyGetDataQuery } from "../../app/services/commonApi";
import { pick } from "./copilotUtils";

const unwrapRecord = (result) => {
  const payload = pick(result, "data", "Data") || result;
  if (!payload) return null;
  if (Array.isArray(payload)) return payload[0] || null;
  const nested = pick(payload, "data", "Data");
  if (Array.isArray(nested)) return nested[0] || null;
  if (nested && typeof nested === "object") return nested;
  return payload;
};

const applicantLabel = (row) => {
  if (!row) return null;
  const first = pick(row, "firstName", "FirstName") || "";
  const last = pick(row, "lastName", "LastName") || "";
  const name = `${first} ${last}`.trim() || pick(row, "applicantName", "ApplicantName");
  return name || null;
};

const openingLabel = (row) => {
  if (!row) return null;
  const name = pick(row, "jobOpeningName", "JobOpeningName");
  return name ? `${name} Opening` : null;
};

export const useCopilotContextDisplay = (rawContext) => {
  const [getRecord] = useLazyGetDataQuery();
  const [entityLabel, setEntityLabel] = useState(rawContext?.entityLabel || null);

  const entityType = rawContext?.entityType;
  const entityId = rawContext?.entityId;

  useEffect(() => {
    let cancelled = false;
    setEntityLabel(rawContext?.entityLabel || null);

    const load = async () => {
      if (!entityId) return;
      try {
        if (entityType === "Applicant") {
          const result = await getRecord({
            url: "/ManageApplicants/GetAllApplicantById",
            data: Number(entityId),
          }).unwrap();
          if (cancelled) return;
          const label = applicantLabel(unwrapRecord(result));
          if (label) setEntityLabel(label);
        } else if (entityType === "JobOpening") {
          const result = await getRecord({
            url: "/JobOpening/JobOpeningGetById",
            data: Number(entityId),
          }).unwrap();
          if (cancelled) return;
          const label = openingLabel(unwrapRecord(result));
          if (label) setEntityLabel(label);
        }
      } catch {
        /* keep type fallback */
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [entityId, entityType, getRecord, rawContext?.entityLabel]);

  return useMemo(
    () => ({
      ...rawContext,
      entityLabel,
    }),
    [rawContext, entityLabel]
  );
};
